import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const SellerAddress = createAsyncThunk(
  "selleraddress/SellerAddress",
  async (data, thunkAPI) => {
    const datas = {
      buildingNumber: data?.buildingNo,
      area: data?.area,
      pincode: data?.pinCode,
      city: data?.city,
      state: data?.state,
      pickupAddress: data?.pinCode,
    };
    try {
      const SellerId = localStorage.getItem("SellerloginData");
      const response = await axios.post(
        `${endPoint.SellerAddressApi}/${SellerId}`,
        {
          datas,
        }
      );
    
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const SellerLoginSlice = createSlice({
  name: "SellerAddressData",
  initialState: {
    SellerAddressData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SellerAddress.fulfilled, (state, action) => {
        state.SellerAddressData = action.payload;
      })
      .addCase(SellerAddress.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default SellerLoginSlice.reducer;
